module.exports = __webpack_public_path__ + "static/img/snyx.d650bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homepage/snyx.jpg
// module id = +zgi
// module chunks = 1